import React from 'react';
import { ComingSoonProvider } from './components/ComingSoonProvider';
import Header from './components/Header';
import Hero from './components/Hero';
import CoreServices from './components/CoreServices';
import ServicesGrid from './components/ServicesGrid';
import FutureVision from './components/FutureVision';
import Technology from './components/Technology';
import AIAutomation from './components/AIAutomation';
import Results from './components/Results';
import Resources from './components/Resources';
import Footer from './components/Footer';

function App() {
  return (
    <ComingSoonProvider>
      <div className="min-h-screen bg-dark-950">
        <Header />
        <main>
          <Hero />
          {/* <CoreServices /> */}
          <ServicesGrid />
          {/* <FutureVision /> */}
          <Technology />
          {/* <AIAutomation /> */}
          {/* <Results /> */}
          {/* <Resources /> */}
        </main>
        <Footer />
      </div>
    </ComingSoonProvider>
  );
}

export default App; 